export default __webpack_public_path__ + "static/media/daohoa1.24d40226.png";